import React from 'react'
import { object, func } from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { changePopup } from '../../modules/Main'

import './Login.scss'

const Thanks = ({ changePopup: changePopupProp }) => (
  <div className='login__wrapper clearfix'>
    <h2>Selamat Bergabung!</h2>
    <p className='otp__subtitle'>Terima kasih telah mendaftar di
    minapoli, temukan beragam kebutuhan perikanan dalam satu platform.</p>
    <div className='login__form noBor'>
      <div className='row'>
        <div className='rl-cl-l-12 clearfix'>
          <button
            type='button'
            className='login__button moreTop'
            onClick={() => { changePopupProp('login') }}>Silahkan Login Kembali</button>
        </div>
      </div>
    </div>
  </div>
)

Thanks.defaultProps = {
  user: { errorLogin: '', loginRequest: false },
  closePortal: () => {},
}

Thanks.propTypes = {
  sendOTP: func.isRequired,
  changePopup: func.isRequired,
  closePortal: func,
  user: object,
}

const mapStateToProps = state => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePopup,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Thanks)



// WEBPACK FOOTER //
// ./src/common/Auth/Thanks.js